import { ArticleHeading5 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ScammerAlert.css';

export const ScammerAlert: React.FC = () => {
  return (
    <div className={styles['container']}>
      <ArticleHeading5 color="text-inverted-default">
        Остерегайтесь мошенничества. Не переходите по ссылкам и не вводите коды смс
      </ArticleHeading5>
    </div>
  );
};
